import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Gallery from '../views/Gallery.vue'
import LocationHS from '../views/LocationHS.vue'
import TestimonialHS from '../views/TestimonialHS.vue'
import OnlineShop from '../views/OnlineShop.vue'
import Services from '../views/Services.vue'
import ListBlogs from '@/views/ListBlogs.vue'
import About from '../views/About.vue'
// appointment
import Appointment from '../views/Appointment.vue'

// login
import Authenticate from '../views/Authenticate.vue'

// Admin

import AdminDashboard from '../views/admin/AdminDashboard.vue'
import AdminProfile from '../views/admin/AdminProfile.vue'
import ManageGallery from '../views/admin/ManageGallery.vue'
import ManageServices from '../views/admin/ManageServices.vue'
import RegisterStylist from '../views/admin/RegisterStylist.vue'

//Stylist
import StylistDashboard from '../views/stylist/StylistDashboard.vue'
import StylistProfile from '../views/stylist/StylistProfile.vue'
import ManageBlogs from '@/views/stylist/ManageBlogs.vue'

const SITE_NAME = 'KC-Afrobraids'
const AUTH_STORAGE_KEY = 'salon_auth';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: `${SITE_NAME} | Professional Hair Salon`,
      description: 'Welcome to KC-Afrobraids — professional Afrobraids, hair cuts, color, and treatments. Book your appointment online.',
    }
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: Gallery,
    meta: {
      title: `Gallery | ${SITE_NAME}`,
      description: 'Browse our portfolio of professional Afrobraids, hair cuts, color treatments, and styling work.',
    }
  },
  {
    path: '/location',
    name: 'location',
    component: LocationHS,
    meta: {
      title: `Location & Contact | ${SITE_NAME}`,
      description: 'Find KC-Afrobraids salon on the map. Get directions, contact information, and business hours.',
    }
  },
/**
 * 
 * Check below for new changes!!
 */
  {
    path: '/blogs',
    name: 'blogs',
    component: ListBlogs,
    meta: {
      title: `Blogs | ${SITE_NAME}`,
      description: 'Browse our Stunning Blogs and Learn more about your hair',
    }
  },

  {
    path: '/testimonial',
    name: 'testimonial',
    component: TestimonialHS,
    meta: {
      title: `Client Reviews | ${SITE_NAME}`,
      description: 'Read what our happy clients say about KC-Afrobraids. Real reviews from real customers.',
    }
  },
  {
    path: '/services',
    name: 'services',
    component: Services,
    meta: {
      title: `Book a Service | ${SITE_NAME}`,
      description: 'Book a professional hair service at KC-Afrobraids. Choose from Afrobraids, cuts, color, treatments, and more.',
    }
  },
  {
    path: '/shop',
    name: 'onlineShop',
    component: OnlineShop,
    meta: {
      title: `Online Shop | ${SITE_NAME}`,
      description: 'Shop professional hair care products from KC-Afrobraids.',
    }
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: {
      title: `About Us | ${SITE_NAME}`,
      description: 'Learn the story behind KC-Afrobraids — our mission, values, and commitment to healthy, beautiful hair.',
    }
  },

  // appointment
  {
    path: '/appointments/:appointmentId/manage',
    name: 'AppointmentManager',
    component: Appointment,
    meta: {
      title: `Manage Appointment | ${SITE_NAME}`,
      robots: 'noindex, nofollow',
    }
  },

  {
    path: '/appointment',
    name: 'AppointmentBooking',
    component: Appointment,
    meta: {
      title: `Book an Appointment | ${SITE_NAME}`,
      description: 'Schedule your appointment at KC-Afrobraids online. Pick your service, date, and time.',
    }
  },

  // login
  {
    path: '/authenticate',
    name: 'Authenticate',
    component: Authenticate,
    meta: {
      title: `Login | ${SITE_NAME}`,
      robots: 'noindex, nofollow',
    }
  },

  {
    path: '/admin/dashboard',
    name: 'adminDashboard',
    component: AdminDashboard,
    meta: { requiresAuth: true, title: `Admin Dashboard | ${SITE_NAME}`, robots: 'noindex, nofollow' },
    beforeEnter: (to, from, next) => {
    const adminData = localStorage.getItem(AUTH_STORAGE_KEY);
  const user = adminData ? JSON.parse(adminData) : null;

  // Check if the route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!user || !user.access_token) {
      next({ name: 'Authenticate' });
    } else {
      next();
    }
  } else {
    next();
  }
    }
  },
  {
    path: '/admin/profile',
    name: 'adminProfile',
    component: AdminProfile,
    meta: { title: `Admin Profile | ${SITE_NAME}`, robots: 'noindex, nofollow' }
  },
  {
    path: '/admin/services',
    name: 'adminServices',
    component: ManageServices,
    meta: { title: `Manage Services | ${SITE_NAME}`, robots: 'noindex, nofollow' }
  },
  {
    path: '/admin/gallery',
    name: 'adminGallery',
    component: ManageGallery,
    meta: { title: `Manage Gallery | ${SITE_NAME}`, robots: 'noindex, nofollow' }
  },
  {
    path: '/admin/register',
    name: 'registerStylist',
    component: RegisterStylist,
    meta: { title: `Register Stylist | ${SITE_NAME}`, robots: 'noindex, nofollow' },
    beforeEnter: (to, from, next) => {
      const adminData = localStorage.getItem(AUTH_STORAGE_KEY)
      const user = adminData ? JSON.parse(adminData) : null
      if (!user || !user.access_token) {
        next({ name: 'Authenticate' })
      } else {
        next()
      }
    }
  },

  {
    path: '/stylist/dashboard',
    name: 'StylistDashboard',
    component: StylistDashboard,
    meta: { title: `Stylist Dashboard | ${SITE_NAME}`, robots: 'noindex, nofollow' },
    beforeEnter: (to, from, next) => {
    const data = localStorage.getItem('salon_auth');
    if (!data) return next({ name: 'Authenticate' });

    const session = JSON.parse(data);
    const isStylist = session.role === 'stylist';
    const googleRequired = session.loginResponse?.google_auth_required;

    if (isStylist && googleRequired) {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('google_auth') === 'success') {
            next();
        } else {
            // back to login because they haven't finished the process
            next({ name: 'Authenticate', query: { error: 'reauth_required' } });
        }
    } else {
        next();
    }
  }
  },
  {
    path: '/stylist/profile',
    name: 'StylistProfile',
    component: StylistProfile,
    meta: { title: `Stylist Profile | ${SITE_NAME}`, robots: 'noindex, nofollow' }
  },
/**
 * Check down here for new edits!!!
 */
  {
    path: '/stylist/blogs',
    name: 'ManageBlogs',
    component: ManageBlogs,
    meta: {
      title: `Manage Blogs | ${SITE_NAME}`,
      description: 'Create and Edit Stunning blogs',
    }
  },

  {
    path: '/payment-success',
    name: 'PaymentSuccess',
    component: Services,
    meta: { title: `Payment Successful | ${SITE_NAME}`, robots: 'noindex, nofollow' }
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const DEFAULT_DESCRIPTION = 'KC-Afrobraids is a professional hair salon specializing in Afrobraids, hair cuts, color, and treatments. Book your appointment online today.'

router.afterEach((to) => {
  // Update page title
  document.title = to.meta.title || `${SITE_NAME} | Professional Hair Salon`

  // Update meta description
  const description = to.meta.description || DEFAULT_DESCRIPTION
  const metaDescription = document.querySelector('meta[name="description"]')
  if (metaDescription) metaDescription.setAttribute('content', description)

  const ogDescription = document.querySelector('meta[property="og:description"]')
  if (ogDescription) ogDescription.setAttribute('content', description)

  const twitterDescription = document.querySelector('meta[name="twitter:description"]')
  if (twitterDescription) twitterDescription.setAttribute('content', description)

  // Update OG title
  const ogTitle = document.querySelector('meta[property="og:title"]')
  if (ogTitle) ogTitle.setAttribute('content', document.title)

  const twitterTitle = document.querySelector('meta[name="twitter:title"]')
  if (twitterTitle) twitterTitle.setAttribute('content', document.title)

  // Update canonical and OG URL
  const canonical = document.querySelector('link[rel="canonical"]')
  if (canonical) canonical.setAttribute('href', window.location.href)

  const ogUrl = document.querySelector('meta[property="og:url"]')
  if (ogUrl) ogUrl.setAttribute('content', window.location.href)

  // Update robots meta
  const robots = document.querySelector('meta[name="robots"]')
  if (robots) robots.setAttribute('content', to.meta.robots || 'index, follow')
})

export default router
